export const cancelHelpHostText = {
  loadingDesc: 'Permintaan Bantuan sedang diproses',
  successDesc: 'Permintaan Bantuan berhasil dibatalkan',
  defaultErrorDesc: "Terjadi kesalahan sistem!"
};

